module.exports = __webpack_public_path__ + "img/s2P7.c7f90b28.png";